import { TopBar } from '@openx/components-table/ChipFilters/TopBar';
import type { FiltersConfig } from '@openx/types/chipFilters';
import { type AllTableCriteria, CriteriaDimension } from '@openx/types/tableCriteria';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { SegmentsListFilters } from '../../types';

type FilterChange = {
  dimension: typeof CriteriaDimension.FILTERS;
  value: SegmentsListFilters;
};

export type SegmentsTopBarProps = {
  onChange: (filters: FilterChange) => void;
  criteria: AllTableCriteria<SegmentsListFilters>;
  filtersConfig: FiltersConfig;
};

export const SegmentsTopBar = memo(({ onChange, criteria, filtersConfig }: SegmentsTopBarProps) => {
  const { t } = useTranslation();

  const handleFiltersChange = useCallback(
    newFilters => {
      onChange({
        dimension: CriteriaDimension.FILTERS,
        value: newFilters,
      });
    },
    [onChange]
  );

  return (
    <TopBar
      filters={criteria.filters}
      onChange={handleFiltersChange}
      searchText={t('Search')}
      chipFiltersConfig={filtersConfig}
    />
  );
});
